//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

jQuery(document).ready(function($){
    $('.karapuro_ranking-1 iframe').iframeTracker({
        blurCallback: function(){
          NicoGoogleTagManagerDataLayer.push({'event':'karapuro_click_douga01'});
          console.log('1');
        }
    });
    $('.karapuro_ranking-2 iframe').iframeTracker({
        blurCallback: function(){
          NicoGoogleTagManagerDataLayer.push({'event':'karapuro_click_douga02'});
          console.log('2');
        }
    });
    $('.karapuro_ranking-3 iframe').iframeTracker({
        blurCallback: function(){
          NicoGoogleTagManagerDataLayer.push({'event':'karapuro_click_douga03'});
        }
    });
    $('.karapuro_ranking-4 iframe').iframeTracker({
        blurCallback: function(){
          NicoGoogleTagManagerDataLayer.push({'event':'karapuro_click_douga04'});
        }
    });
    $('.karapuro_ranking-5 iframe').iframeTracker({
        blurCallback: function(){
          NicoGoogleTagManagerDataLayer.push({'event':'karapuro_click_douga05'});
        }
    });
    $('.karapuro_ranking-6 iframe').iframeTracker({
        blurCallback: function(){
          NicoGoogleTagManagerDataLayer.push({'event':'karapuro_click_douga06'});
        }
    });
    $('.karapuro_ranking-7 iframe').iframeTracker({
        blurCallback: function(){
          NicoGoogleTagManagerDataLayer.push({'event':'karapuro_click_douga07'});
        }
    });
});


// WEBPACK FOOTER //
// script.js